import { render, staticRenderFns } from "./ResetSelfService.vue?vue&type=template&id=476c4a2c&scoped=true"
import script from "./ResetSelfService.vue?vue&type=script&lang=js"
export * from "./ResetSelfService.vue?vue&type=script&lang=js"
import style0 from "./ResetSelfService.vue?vue&type=style&index=0&id=476c4a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476c4a2c",
  null
  
)

export default component.exports